import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import Products from 'merchandise-lib/constants/Product';
const VersionNumbers = {
  [Products.ADS_LIMIT_INCREASE]: {},
  [Products.AEO_ANSWERS_LIMIT_INCREASE]: {},
  [Products.AEO_STANDALONE]: {},
  [Products.API_LIMIT_INCREASE]: {},
  [Products.BRAZIL_ONBOARDING]: {},
  [Products.BRAND_DOMAIN]: {},
  [Products.BREEZE_INTELLIGENCE_CREDITS_100]: {},
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000]: {},
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000]: {},
  [Products.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: {},
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: {},
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: {},
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100]: {},
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000]: {},
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000]: {},
  [Products.CALCULATED_PROPERTIES_LIMIT_INCREASE]: {},
  [Products.CALLING_LIMIT_INCREASE]: {},
  [Products.CMS_HUB_ENTERPRISE]: {
    LATEST: 4,
    LATEST_PRESEATS: 3
  },
  [Products.CMS_HUB_ENTERPRISE_ONBOARDING]: {},
  [FreeProducts.CMS_HUB_FREE]: {},
  [Products.CMS_HUB_PROFESSIONAL]: {
    LATEST: 12,
    LATEST_PRESEATS: 11
  },
  [Products.CMS_HUB_PROFESSIONAL_ONBOARDING]: {},
  [Products.CMS_HUB_STARTER]: {
    LATEST: 7,
    LATEST_PRESEATS: 6
  },
  [Products.CORE_SEATS_ENTERPRISE]: {
    SMART_CRM: 2,
    LATEST: 2
  },
  [Products.CORE_SEATS_INCLUDED_STARTER]: {},
  [Products.CORE_SEATS_PROFESSIONAL]: {
    SMART_CRM: 2,
    LATEST: 2
  },
  [Products.CORE_SEATS_STARTER]: {},
  [Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE]: {},
  [Products.CRM_OBJECT_LIMIT_INCREASE]: {},
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: {
    LATEST: 2
  },
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: {
    LATEST: 2
  },
  [Products.CRM_SUITE_STARTER_BUNDLE]: {
    LATEST: 3
  },
  [Products.CUSTOM_OBJECTS_LIMIT_INCREASE]: {},
  [Products.CUSTOM_PROPERTIES_LIMIT_INCREASE]: {},
  [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: {},
  [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: {
    LEGACY: 1,
    EARLY_2020: 3
  },
  [Products.DOMAINS_LIMIT_INCREASE]: {},
  [Products.ESIGNATURE_LIMIT_INCREASE]: {},
  [Products.FIRST_TIME_FULL_MIGRATION]: {},
  [Products.HUBSPOT_FOR_STARTUPS_SETUP]: {},
  [FreeProducts.HUBSPOT_FREE]: {},
  [Products.INBOUND_CONSULTING_ADVANCED]: {},
  [Products.INBOUND_CONSULTING_PREMIUM]: {},
  [Products.LISTS_LIMIT_INCREASE]: {},
  [Products.MARKETING_HUB_BASIC]: {},
  [Products.MARKETING_HUB_ENTERPRISE]: {
    LATEST: 15,
    LATEST_PRESEATS: 14,
    MARKETING_CONTACTS: 12
  },
  [Products.MARKETING_HUB_ENTERPRISE_ONBOARDING]: {},
  [FreeProducts.MARKETING_HUB_FREE]: {},
  [Products.MARKETING_HUB_PROFESSIONAL]: {
    LATEST: 15,
    LATEST_PRESEATS: 14,
    MARKETING_CONTACTS: 12
  },
  [Products.MARKETING_HUB_PROFESSIONAL_ONBOARDING]: {},
  [Products.MARKETING_HUB_STARTER]: {
    LATEST: 8,
    LATEST_PRESEATS: 7,
    LEGACY_250: 2,
    NOV_2019: 3,
    MARKETING_CONTACTS: 4
  },
  [Products.MARKETING_HUB_STARTER_ONBOARDING]: {},
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: {
    LATEST: 1,
    LATEST_PRESEATS: 2
  },
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: {
    LATEST: 1,
    LATEST_PRESEATS: 2
  },
  [Products.MARKETING_SMS]: {},
  [Products.MARKETING_SMS_LIMIT_INCREASE]: {},
  [Products.MARKETING_SMS_SHORT_CODE]: {},
  [Products.ONBOARDING_FOUNDATIONS]: {},
  [Products.HUBSPOT_ACADEMY_GUIDED_ONBOARDING]: {},
  [Products.OPERATIONS_HUB_ENTERPRISE]: {
    LATEST: 2,
    LATEST_PRESEATS: 1
  },
  [FreeProducts.OPERATIONS_HUB_FREE]: {},
  [Products.OPERATIONS_HUB_PROFESSIONAL]: {
    LATEST: 2,
    LATEST_PRESEATS: 1
  },
  [Products.OPERATIONS_HUB_STARTER]: {
    LATEST: 3,
    LATEST_PRESEATS: 1
  },
  [Products.PHONE_LIMIT_INCREASE]: {},
  [Products.PREMIUM_CONSULTING]: {},
  [Products.REPORTING_LIMIT_INCREASE]: {},
  [Products.SALES_HUB_ENTERPRISE]: {
    LATEST: 3,
    LATEST_PRESEATS: 1,
    QUANTIFIABLE_SEAT: 3
  },
  [Products.SALES_HUB_ENTERPRISE_ONBOARDING]: {},
  [FreeProducts.SALES_HUB_FREE]: {},
  [Products.SALES_HUB_PROFESSIONAL]: {
    LATEST: 7,
    LATEST_PRESEATS: 5,
    LEGACY_BUSINESS_USER: 3,
    QUANTIFIABLE_SEAT: 7
  },
  [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: {},
  [Products.SALES_HUB_STARTER]: {
    LATEST: 5,
    LATEST_PRESEATS: 3,
    LEGACY: 1,
    MARCH_2020: 3
  },
  [Products.SALES_HUB_STARTER_ONBOARDING]: {},
  [Products.SANDBOX_LIMIT_INCREASE]: {},
  [Products.SERVICE_HUB_ENTERPRISE]: {
    LATEST: 3,
    LATEST_PRESEATS: 1,
    QUANTIFIABLE_SEAT: 3
  },
  [Products.SERVICE_HUB_ENTERPRISE_ONBOARDING]: {},
  [FreeProducts.SERVICE_HUB_FREE]: {},
  [Products.SERVICE_HUB_PROFESSIONAL]: {
    LATEST: 2,
    LATEST_PRESEATS: 1,
    QUANTIFIABLE_SEAT: 2
  },
  [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: {},
  [Products.SERVICE_HUB_STARTER]: {
    LATEST: 4,
    LATEST_PRESEATS: 2,
    LEGACY: 1,
    MARCH_2020: 2
  },
  [Products.SERVICE_HUB_STARTER_ONBOARDING]: {},
  [Products.STARTER_KIT]: {},
  [Products.STRATEGIC_CONSULTING_4_HOUR]: {},
  [Products.STRATEGIC_CONSULTING_MONTHLY]: {},
  [Products.STRATEGIC_CONSULTING_ONGOING]: {},
  [Products.TEAMS_LIMIT_INCREASE]: {},
  [Products.TECHNICAL_CONSULTING_4_HOUR]: {},
  [Products.TECHNICAL_CONSULTING_ADVANCED]: {},
  [Products.TECHNICAL_CONSULTING_ONGOING]: {},
  [Products.TECHNICAL_CONSULTING_PREMIUM]: {},
  [Products.TRAINING_AGENCY_MARKETING_HUB_FUNDAMENTALS]: {},
  [Products.TRANSACTIONAL_EMAIL]: {},
  [Products.TRANSCRIPTION_LIMIT_INCREASE]: {},
  [Products.USERS_LIMIT_INCREASE]: {},
  [Products.VIDEO_LIMIT_INCREASE]: {},
  [Products.WHATSAPP_LIMIT_INCREASE]: {},
  [Products.WORKFLOWS_LIMIT_INCREASE]: {},
  [Products.HUBSPOT_CREDITS_COMMITTED]: {},
  [Products.HUBSPOT_CREDITS_COMMITTED_OVERAGE]: {},
  [Products.HUBSPOT_CREDITS_OVERAGE]: {},
  [Products.COMMERCE_HUB_PROFESSIONAL]: {},
  [Products.COMMERCE_HUB_ENTERPRISE]: {},
  [FreeProducts.COMMERCE_HUB_FREE]: {},
  [Products.ADVANCED_ONBOARDING]: {},
  [Products.ADVANCED_ONBOARDING_MIGRATION_SERVICES]: {},
  [Products.AGENCY_PIPELINE_GENERATION_TRAINING_PLUS]: {},
  [Products.AGENCY_SALES_SKILLS_TRAINING_PLUS]: {},
  [Products.ASSET_MIGRATION_BASE]: {},
  [Products.ASSET_MIGRATION_PREMIUM]: {},
  [Products.BASIC_DESIGNATED_ACCOUNT_SERVICES]: {},
  [Products.BLOG_MIGRATION]: {},
  [Products.BREEZE_INTELLIGENCE_BACKFILL_ENRICHMENT]: {},
  [Products.BREEZE_INTELLIGENCE_BULK_ENRICHMENT]: {},
  [Products.BUSINESS_UNIT_EXTENSION]: {},
  [Products.CREATING_EFFECTIVE_INBOUND_CONTENT_TRAINING]: {},
  [Products.CRM_DATA_MIGRATION]: {},
  [Products.CRM_SUITE_ONBOARDING_ENTERPRISE]: {},
  [Products.CRM_SUITE_ONBOARDING_PREMIER]: {},
  [Products.CRM_SUITE_ONBOARDING_PROFESSIONAL]: {},
  [Products.CRM_TRAINING]: {},
  [Products.CUSTOM_CLASSROOM_TRAINING]: {},
  [Products.CUSTOM_CONSULTING]: {},
  [Products.DATA_MIGRATION_CONSULTING]: {},
  [Products.DATA_WAREHOUSE]: {},
  [Products.EMAIL_TEMPLATE_SETUP]: {},
  [Products.ENTERPRISE_EDUCATION_PROGRAM]: {},
  [Products.ENTERPRISE_SUITE_ONBOARDING]: {},
  [Products.EXECUTIVE_SUMMIT_HOW_HUBSPOT_BUILT_ITS_SALES_AND_MARKETING_MACHINE]: {},
  [Products.FIRST_TIME_BLOG_MIGRATION]: {},
  [Products.FRIENDS_AND_FAMILY]: {},
  [Products.FULL_MIGRATION]: {},
  [Products.GOLD_CRM_DATA_MIGRATION]: {},
  [Products.GRANTED_CORE_SEATS]: {},
  [Products.HUBSPOT_CRM_DATA_MIGRATION]: {},
  [Products.HUBSPOT_IMPLEMENTATION_CONSULTING]: {},
  [Products.IMPLEMENTATION_FEE_20K]: {},
  [Products.INBOUND_CONSULTING_FOR_PARTNERS]: {},
  [Products.INBOUND_CONSULTING_NEW_USER_TRAINING]: {},
  [Products.INBOUND_SUCCESS_CONTENT_ADVANTAGE]: {},
  [Products.INBOUND_SUCCESS_NON_PROFIT_ADVANTAGE]: {},
  [Products.INDUSTRY_BUSINESS_CONSULTING_ONGOING]: {},
  [Products.INDUSTRY_TECHNICAL_CONSULTING_ONGOING]: {},
  [Products.INTEGRATION_SUPPORT]: {},
  [Products.LARGE_SERVICES]: {},
  [Products.LEAD_MANAGEMENT_AND_AUTOMATION_TRAINING]: {},
  [Products.LEGACY_MARKETING]: {},
  [Products.LEGACY_SALES_HUB_PROFESSIONAL_LIMITS]: {},
  [Products.MARKETING_HUB_ADVANCED_ONBOARDING]: {},
  [Products.MARKETING_HUB_ATTRACT_LEADS_TRAINING]: {},
  [Products.MARKETING_HUB_BASIC_ONBOARDING]: {},
  [Products.MARKETING_HUB_ENTERPRISE_LEGACY_FEATURES]: {},
  [Products.MARKETING_HUB_ENTERPRISE_ONBOARDING_LATAM]: {},
  [Products.MARKETING_HUB_GENERATE_LEADS_TRAINING]: {},
  [Products.MARKETING_HUB_HANDOFF_LEADS_TRAINING]: {},
  [Products.MARKETING_HUB_NURTURE_LEADS_TRAINING]: {},
  [Products.MARKETING_HUB_PROFESSIONAL_ONBOARDING_LATAM]: {},
  [Products.MIGRATE_THEME]: {},
  [Products.MIGRATE_THEME_CONTENT_MIGRATION]: {},
  [Products.MIGRATION_CONSULTING_4_HOUR]: {},
  [Products.MULTIPLE_PREMIERE_ONBOARDING]: {},
  [Products.NETSUITE_UPDATE_TEST]: {},
  [Products.ONBOARDING_EXTENSION_4_HOUR]: {},
  [Products.ONE_TIME_CREDIT]: {},
  [Products.ONE_TIME_INBOUND_CONSULTING_FOR_PARTNERS]: {},
  [Products.ONE_TIME_TECHNICAL_CONSULTING_FOR_PARTNERS]: {},
  [Products.ONSITE_ONBOARDING]: {},
  [Products.PARTNER_20K_IMPLEMENTATION_FEE]: {},
  [Products.PARTNER_ONBOARDING]: {},
  [Products.PARTNER_ONBOARDING_FOUNDATIONS]: {},
  [Products.PARTNER_PIPELINE_GENERATION_BOOTCAMP_PRO_TRAINING]: {},
  [Products.PARTNER_PRIVATE_CUSTOMER_TRAINING_BASE]: {},
  [Products.PARTNER_PRIVATE_CUSTOMER_TRAINING_BASE_ONSITE]: {},
  [Products.PARTNER_PRIVATE_TRAINING_PREMIUM]: {},
  [Products.PARTNER_SALES_SKILLS_BOOTCAMP_PRO_TRAINING]: {},
  [Products.PARTNER_TECHNICAL_ACCELERATOR]: {},
  [Products.PAST_DUE_AMOUNT]: {},
  [Products.PREMIUM_SUPPORT]: {},
  [Products.PREMIUM_SUPPORT_SKU]: {},
  [Products.PRIVATE_CUSTOMER_TRAINING_BASE]: {},
  [Products.PRIVATE_CUSTOMER_TRAINING_BASE_ONSITE]: {},
  [Products.PRIVATE_TRAINING_BASE]: {},
  [Products.PRIVATE_TRAINING_PREMIUM]: {},
  [Products.PROFESSIONAL_SUITE_ONBOARDING]: {},
  [Products.QUICK_START_CONSULTATION]: {},
  [Products.REFUND]: {},
  [Products.REMOTE_TEAM_TRAINING]: {},
  [Products.REOPEN_PORTAL]: {},
  [Products.REPORTING_ADD_ON_TRAINING]: {},
  [Products.SALES_AND_MARKETING_ALIGNMENT]: {},
  [Products.SALES_HUB_ADVANCED_ONBOARDING]: {},
  [Products.SALES_HUB_AUTOMATION_TRAINING]: {},
  [Products.SALES_HUB_CONFIGURE_YOUR_DEAL_PIPELINE_TRAINING]: {},
  [Products.SALES_HUB_PRODUCTIVITY_TOOLS_TRAINING]: {},
  [Products.SALES_HUB_REPORTING_TRAINING]: {},
  [Products.SALES_SETUP]: {},
  [Products.SENSITIVE_DATA]: {},
  [Products.SERVICE_AVISON_YOUNG_IMPLEMENTATION]: {},
  [Products.SERVICE_BLOCK_4_HOUR]: {},
  [Products.SERVICE_BLOCK_8_HOUR]: {},
  [Products.SERVICE_HUB_FUNDAMENTALS]: {},
  [Products.SERVICE_SMS]: {},
  [Products.SILVER_CRM_DATA_MIGRATION]: {},
  [Products.STRATEGIC_CONSULTING_1_DAY]: {},
  [Products.TECH_SERVICE_FIRST_TIME_TEMPLATE_SETUP]: {},
  [Products.TECH_SERVICE_TEMPLATE_SETUP]: {},
  [Products.TECHNICAL_CONSULTING_1_DAY]: {},
  [Products.TECHNICAL_CONSULTING_OPERATIONS_HUB_DATASYNC]: {},
  [Products.TECHNICAL_CONSULTING_OPERATIONS_HUB_PROGRAMMABLE_AUTOMATION]: {},
  [Products.TECHNICAL_CONSULTING_PARTNERS]: {},
  [Products.TRAINING_AGENCY_ACCOUNT_MANAGEMENT_ESSENTIALS]: {},
  [Products.TRAINING_AGENCY_CRM_MANAGEMENT]: {},
  [Products.TRAINING_BUILDING_AN_INBOUND_CAMPAIGN_FUNDAMENTALS]: {},
  [Products.TRAINING_OPTIMIZING_YOUR_SALES_WITH_HUBSPOT_CRM_TRAINING_COURSE]: {},
  [Products.TRAINING_SALES_AND_MARKETING_ALIGNMENT]: {},
  [Products.TRAINING_SALES_HUB_FUNDAMENTALS]: {},
  [Products.UNLIMITED_CONTACTS]: {},
  [Products.WEB_HOSTING_SSL_PACK]: {},
  [Products.CONVERSATIONAL_ANALYSIS_LIMIT_INCREASE]: {},
  [Products.CORE_SEATS_STARTER_HSOC]: {},
  [Products.CORE_SEATS_PROFESSIONAL_HSOC]: {},
  [Products.CORE_SEATS_ENTERPRISE_HSOC]: {},
  [Products.ENTERPRISE_FLEX_PROGRAM]: {},
  [Products.FLEX_SEAT]: {},
  [Products.FLEX_SEAT_OVERAGE]: {},
  [Products.FRONT_OFFICE_SEATS_ENTERPRISE]: {},
  [Products.FRONT_OFFICE_SEATS_PROFESSIONAL]: {},
  [Products.SOLUTIONS_PARTNER_PROGRAM]: {},
  [Products.EMAIL_CAPACITY_BUNDLE_EXTRA_LARGE]: {},
  [Products.EMAIL_CAPACITY_BUNDLE_LARGE]: {},
  [Products.EMAIL_CAPACITY_BUNDLE_MEDIUM]: {},
  [Products.EMAIL_CAPACITY_BUNDLE_SMALL]: {},
  [Products.WORKFLOW_CAPACITY_BUNDLE_EXTRA_LARGE]: {},
  [Products.WORKFLOW_CAPACITY_BUNDLE_LARGE]: {},
  [Products.WORKFLOW_CAPACITY_BUNDLE_MEDIUM]: {},
  [Products.WORKFLOW_CAPACITY_BUNDLE_SMALL]: {},
  [Products.MARKETING_CONTACTS_ENTERPRISE]: {},
  [Products.BASIC_RECORDS_LIMIT_INCREASE]: {},
  [Products.SCALED_RECORDS_LIMIT_INCREASE]: {}
};
export default VersionNumbers;